// fressnapf_main_2089 Global | All Profiles | Has Dog Affinity
// fressnapf_main_2088 Global | All Profiles | Has Cat Affinity
function getAffinitySegments($i18n: any) {
  return new Map([
    [$i18n.t('tealium.segments.cat'), 'CAT'],
    [$i18n.t('tealium.segments.dog'), 'DOG'],
  ]);
}

function getAffinityType(audiences: string[], $i18n: any): string | undefined {
  const affinitySegments = getAffinitySegments($i18n);

  const matched = Array.from(affinitySegments.entries())
    .filter(([segment]) => audiences.includes(segment))
    .map(([, type]) => type);
  return matched.length === 1 ? matched[0] : undefined;
}

export function useAffinityCookie() {
  const { $i18n } = useNuxtApp();
  const mainStore = useMainStore();
  const affinityRedirectPageCookie = useCookie('affinityRedirectPage', { maxAge: ONE_YEAR });

  function setAffinityCookie(audiences: string[]) {
    const affinityType = getAffinityType(audiences, $i18n);

    if (!mainStore.getFeature('affinityRedirectEnabled')) {
      affinityRedirectPageCookie.value = null;
      return;
    }
    affinityRedirectPageCookie.value = affinityType ? $i18n.t(`pets.types.${affinityType}`).toLowerCase() : null;
  }

  return { setAffinityCookie, affinityRedirectPageCookie };
}
